import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import Slide from '@mui/material/Slide'
import { useParams, useHistory } from 'react-router-dom'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import Button from '@mui/material/Button'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import CheckIcon from '@mui/icons-material/Check'
import { toast } from 'react-toastify'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import { UrlParams } from '../../types'
import YellowSwitch from '../../common/YellowSwitch'
import DashboardLayout from '../layouts/DashboardLayout'
import ColorButton from '../../common/ColorButton'
import getFirestoreDocById from '../../common/getFirestoreDocById'
import { doc, updateDoc, db } from '../../config/firebaseConfig'
import useAuth from '../../hooks/useAuth'
import color1ConsoleLog from '../../common/color1ConsoleLog'
import FullPageLoader from '../../common/FullPageLoader'

const ReviseStep9 = () => {
  console.log('ReviseStep9')

  const { user } = useAuth()
  console.log('%cuser : %s', color1ConsoleLog, user?.uid)

  const { id, area } = useParams<UrlParams>()
  console.log('%cThe id is : %s', color1ConsoleLog, id)
  console.log('%cThe area is : %s', color1ConsoleLog, area)

  const history = useHistory()

  const goToReviseStep8 = () => {
    history.push(`/revision/${area}/8/${id}`)
  }

  const goToReviseStep10 = () => {
    history.push(`/revision/${area}/10/${id}`)
  }

  const [formData, setFormData]: any = useState()
  const [loading, setLoading] = useState(true)
  const [isAllowed, setIsAllowed] = useState(false)
  const [key, setKey] = useState('')
  // eslint-disable-next-line
  const [areaUrlParam, setAreaUrlParam] = useState('')
  const [approvedAt, setApprovedAt] = useState('')

  useEffect(() => {
    (async () => {
      if (id) {
        const res = await getFirestoreDocById(id)
        if (res) {
          setFormData(res)
          if (area === 'tsu') {
            console.log('res?.p16workSupervisor', res?.p16workSupervisor)
            console.log('%cp16workSupervisor has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16workSupervisorApproved9')
            setAreaUrlParam('tsu')
            setApprovedAt('p16workSupervisorApprovedAt9')
          }
          if (area === 'pep') {
            console.log('%cp16pepCoordinator has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16pepCoordinatorApproved9')
            setAreaUrlParam('pep')
            setApprovedAt('p16pepCoordinatorApprovedAt9')
          }
          if (area === 'aco') {
            console.log('%cp16areaCoordinator has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16areaCoordinatorApproved9')
            setAreaUrlParam('aco')
            setApprovedAt('p16areaCoordinatorApprovedAt9')
          }
          if (area === 'qt') {
            console.log('%cp16quality has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16qualityApproved9')
            setAreaUrlParam('qt')
            setApprovedAt('p16qualityApprovedAt9')
          }
          if (area === 'ta') {
            console.log('%cp16technicalArea has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16technicalAreaApproved9')
            setAreaUrlParam('ta')
            setApprovedAt('p16technicalAreaApprovedAt9')
          }
          if (area === 'ps') {
            console.log('%cp16patrimonialSecurity has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16patrimonialSecurityApproved9')
            setAreaUrlParam('ps')
            setApprovedAt('p16patrimonialSecurityApprovedAt9')
          }
          if (area === 'ep') {
            console.log('%cp16externalPrevencionist has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16externalPrevencionistApproved9')
            setAreaUrlParam('ep')
            setApprovedAt('p16externalPrevencionistApprovedAt9')
          }
          if (area === 'sass') {
            console.log('%cp16sass has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16sassApproved9')
            setAreaUrlParam('sass')
            setApprovedAt('p16sassApprovedAt9')
          }
          setLoading(false)
        } else {
          setLoading(false)
        }
      }
    })()
  }, [])

  if (loading) {
    <Typography>Cargando</Typography>
  }
  console.log(formData)

  const approve = async (e: any) => {
    e.preventDefault()
    const approveformRef = doc(db, 'forms', id)
    const obj: any = {}
    obj[key] = true
    obj[approvedAt] = new Date()
    try {
      await updateDoc(approveformRef, obj)
      console.log('approved', key, approvedAt)
      toast.success('La aprobación se actualizó correctamente')
    } catch (updateError) {
      toast.error(`Error: ${updateError}`)
    }
  }

  const disapprove = async (e: any) => {
    e.preventDefault()
    const approveformRef = doc(db, 'forms', id)
    const obj: any = {}
    obj[key] = false
    obj[approvedAt] = new Date()
    try {
      await updateDoc(approveformRef, obj)
      console.log('disapproved', key, approvedAt)
      toast.success('La desaprobación se actualizó correctamente')
    } catch (updateError) {
      toast.error(`Error: ${updateError}`)
    }
  }

  return (
    <DashboardLayout>
      {loading ? <FullPageLoader /> : (
        <Slide direction="right" in mountOnEnter unmountOnExit>
          <Grid sx={{ mt: 4 }} container justifyContent="center" spacing={2}>
            <Grid item xs={10} sm={9} md={5} lg={7}>
              {
                (formData?.p16workSupervisor === user?.uid)
                  || (formData?.p16pepCoordinator === user?.uid)
                  || (formData?.p16areaCoordinator === user?.uid)
                  || (formData?.p16quality === user?.uid)
                  || (formData?.p16technicalArea === user?.uid)
                  || (formData?.p16patrimonialSecurity === user?.uid)
                  || (formData?.p16externalPrevencionist === user?.uid)
                  || (formData?.p16sass === user?.uid)
                  || (formData?.p16sassAllowedList?.includes(user?.uid))
                  ? (
                    <>
                      <Typography
                        sx={{ mb: 2 }}
                        align="center"
                        variant="h6"
                        color="text.secondary"
                        gutterBottom
                      >
                        IZAJE
                      </Typography>

                      <Grid display="flex" justifyContent="center" item xs={12}>
                        <FormControlLabel
                          control={(
                            <YellowSwitch
                              checked={formData?.p9Show}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          )}
                          label={formData?.p9Show ? 'Esta página aplica' : 'Esta página no aplica'}
                        />
                      </Grid>

                      <Box
                        component="div"
                        sx={{
                          display: formData?.p9Show ? 'block' : 'none',
                        }}
                      >
                        <Box sx={{
                          display: 'flex', justifyContent: 'center', mt: 4, mb: 2,
                        }}
                        >
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">Revisión Eslingas</FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="atrapamiento"
                              name="atrapamiento"
                              value={formData?.p9eslingasCheck}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p9eslingasCheck === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p9eslingasCheck === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p9eslingasCheck === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>

                        </Box>

                        {(formData?.p9eslingasCheckImage?.length > 1 && formData?.p9eslingasCheckImage !== 'none')
                          && (
                            <Card sx={{ maxWidth: 345, mt: 2, mb: 4 }}>
                              <CardMedia
                                component="img"
                                height="140"
                                image={
                                  formData?.p9eslingasCheckImage
                                  && formData?.p9eslingasCheckImage
                                }
                                alt="revisión Eslingas"
                              />
                              <CardContent>
                                <Typography gutterBottom variant="subtitle1" component="div">
                                  Revisión Eslingas
                                </Typography>
                              </CardContent>
                            </Card>
                          )}

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">Revisión de puntos de anclaje</FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="aplastamiento"
                              name="aplastamiento"
                              value={formData?.p9ancPointCheck}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p9ancPointCheck === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p9ancPointCheck === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p9ancPointCheck === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Grid display="flex" justifyContent="center" sx={{ mb: 2 }} item xs={12}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">Establecer perímetro de seguridad (indicar área)</FormLabel>
                            <Grid display="flex" justifyContent="center" item xs={12}>
                              <RadioGroup
                                sx={{ flex: '1', flexDirection: 'row', justifyContent: 'center' }}
                                aria-label="golpeadorpor"
                                name="golpeadorpor"
                                value={formData?.p9securityPerimeter}
                              >
                                <FormControlLabel value="SI" control={<Radio checked={formData?.p9securityPerimeter === 'SI'} />} label="SI" />
                                <FormControlLabel value="NO" control={<Radio checked={formData?.p9securityPerimeter === 'NO'} />} label="NO" />
                                <FormControlLabel value="NA" control={<Radio checked={formData?.p9securityPerimeter === 'NA'} />} label="N/A" />
                              </RadioGroup>
                            </Grid>
                          </FormControl>
                        </Grid>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">Participación RIGGER</FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="golpeadocon"
                              name="golpeadocon"
                              value={formData?.p9riggerParticipation}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p9riggerParticipation === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p9riggerParticipation === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p9riggerParticipation === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Requiere bloquear áreas de tránsito
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="caida"
                              name="caida"
                              value={formData?.p9transitAreas}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p9transitAreas === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p9transitAreas === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p9transitAreas === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Informa a jefaturas de áreas a bloquear
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="contactoconobjetoscortantes"
                              name="contactoconobjetoscortantes"
                              value={formData?.p9informBlockAreasToJef}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p9informBlockAreasToJef === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p9informBlockAreasToJef === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p9informBlockAreasToJef === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Delimitación del área
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="contactoconobjetoscalientes"
                              name="contactoconobjetoscalientes"
                              value={formData?.p9areaDelimitation}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p9areaDelimitation === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p9areaDelimitation === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p9areaDelimitation === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 10 }} component="fieldset">
                            <FormLabel component="legend">
                              Chequeo previo del camión
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="proyecciondeparticulas"
                              name="proyecciondeparticulas"
                              value={formData?.p9truckPrevCheck}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p9truckPrevCheck === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p9truckPrevCheck === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p9truckPrevCheck === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        {(formData?.p9truckPrevCheckImage?.length > 1 && formData?.p9truckPrevCheckImage !== 'none')
                          && (
                            <Card sx={{ maxWidth: 345, mt: 2, mb: 4 }}>
                              <CardMedia
                                component="img"
                                height="140"
                                image={
                                  formData?.p9truckPrevCheckImage
                                  && formData?.p9truckPrevCheckImage
                                }
                                alt="chequeo previo del camión"
                              />
                              <CardContent>
                                <Typography gutterBottom variant="subtitle1" component="div">
                                  Chequeo previo del camión
                                </Typography>
                              </CardContent>
                            </Card>
                          )}

                      </Box>

                      <Grid
                        display={isAllowed ? 'flex' : 'none'}
                        justifyContent="space-evenly"
                        sx={{ mt: 4 }}
                      >
                        <Button
                          startIcon={<HighlightOffIcon />}
                          sx={{ mb: 10, bgcolor: '#db1414' }}
                          color="error"
                          variant="contained"
                          onClick={(e) => disapprove(e)}
                        >
                          Desaprobar
                        </Button>
                        <Button
                          startIcon={<CheckIcon />}
                          sx={{ mb: 10, bgcolor: '#42b50e' }}
                          color="success"
                          variant="contained"
                          onClick={(e) => approve(e)}
                        >
                          Aprobar
                        </Button>
                      </Grid>

                      <Grid sx={{ mb: 2 }} container justifyContent="space-between">
                        <Grid
                          xs={12}
                          md={5}
                          sx={{ mb: 2 }}
                        >
                          <ColorButton
                            fullWidth
                            startIcon={<ArrowLeftIcon />}
                            onClick={goToReviseStep8}
                          >
                            Ir a la página anterior
                          </ColorButton>
                        </Grid>
                        <Grid
                          xs={12}
                          md={5}
                        >
                          <ColorButton
                            fullWidth
                            endIcon={<ArrowRightIcon />}
                            onClick={goToReviseStep10}
                          >
                            Ir a la página siguiente
                          </ColorButton>
                        </Grid>

                      </Grid>
                    </>
                  )
                  : 'Por favor inicie sesión para visualizar su documento a revisar'
              }

              {user ? (
                <Typography color="green">Usted ha iniciado sesión.</Typography>
              )
                : (
                  <Typography color="red" sx={{ mt: 2 }}>Usted no ha iniciado sesión</Typography>
                )}

            </Grid>
          </Grid>
        </Slide>
      )}

    </DashboardLayout>
  )
}

export default ReviseStep9